import { Domain } from '@policyfly/protobuf/pfbingo'
import { defineStore } from 'pinia'
import { computed, shallowRef } from 'vue'

interface DomainOption {
  name: string
  value: Domain
}

const domainOptions: DomainOption[] = [
  { name: 'PF Core', value: Domain.DOMAIN_PF_CORE },
  { name: 'Capture', value: Domain.DOMAIN_CAPTURE },
  { name: 'Accounting', value: Domain.DOMAIN_ACCOUNTING },
  { name: 'API', value: Domain.DOMAIN_API },
  { name: 'Reporting', value: Domain.DOMAIN_REPORTING },
]

export const useDomainStore = defineStore('domain', () => {
  const currentDomainRef = shallowRef<Domain>(Domain.DOMAIN_PF_CORE)

  function setCurrentDomain (domain: Domain): void {
    currentDomainRef.value = domain
  }

  const domains = computed(() => domainOptions)
  const currentDomain = computed(() => currentDomainRef.value)

  return {
    domains,
    currentDomain,
    setCurrentDomain,
  }
})
